module.exports = __webpack_public_path__ + "img/btn_AddHolidays@2x.f81292d7.png";